export default __webpack_public_path__ + "huff-post.f25b2570.png";